import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonContent,
  IonIcon,
  IonButtons,
  IonItem,
  IonList,
  IonLabel,
  IonText,
  IonImg,
  IonAvatar,
} from '@ionic/react';
import { sparklesOutline, ribbonOutline, close } from 'ionicons/icons';
import { LOYALTY_JOIN_CONFIRM } from 'pages/Loyalty';
import { useDispatch } from 'react-redux';
import PayActions from 'redux/PayRedux';
import storage from 'utils/storage';

function LoyaltyJoinModal({ isOpen, venueDetail, rewardLevels, setLoyaltyTypeModal, programId }) {
  const dispatch = useDispatch();

  const filterRewardLevels = useMemo(() => {
    if (!venueDetail || !rewardLevels.length)
      return [];

    const filterLevels = rewardLevels.filter(item => item.venueId === venueDetail.id);

    return filterLevels.sort(((a, b) => a.points - b.points));

  }, [venueDetail, rewardLevels])

  const onCloseAction = async () => {
    await storage.setItem('PREP_LOYALTY_JOIN_MODAL', 'true');
    setLoyaltyTypeModal(null);
  }

  const onJoinAction = () => {
    if (!programId) {
      return;
    }

    dispatch(PayActions.setOptInProgram(programId));

    setLoyaltyTypeModal(LOYALTY_JOIN_CONFIRM);
  }

  return (
    <IonModal isOpen={isOpen} className="custom-loyalty-modal">
      <IonItem lines="none" className="mt">
        <IonButtons
          slot="end"
          onClick={onCloseAction}
        >
          <IonButton
            color="tertiary"
          >
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonItem>

      <IonContent>
        <IonList>
          <IonItem lines="none">
            <div className="d-flex-content d-flex-center loyalty-venue-logo-wrapper">
              <IonAvatar slot="start" className="loyalty-venue-logo-size">
                <IonImg src={venueDetail?.logo} />
              </IonAvatar>
            </div>
          </IonItem>

          <IonItem lines="none" className="mb-5x">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="text-center ion-text-wrap">
                <h2>Join {venueDetail?.name} Loyalty Program{venueDetail?.hasSignUpBonus ? ' and get $2.00 off today!' : ''}</h2>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mb-2x">
            <div className="loyal-icon-wrapper">
              <IonText className="loyalty-dollar-text">$</IonText>
            </div>

            <div className="d-flex-content ml-2">
              <IonLabel className="ion-text-wrap">
                <IonText color="dark"><h6>Earn 1 coin for every dollar</h6></IonText>
              </IonLabel>
              <IonLabel className="ion-text-wrap">
                <IonText color="medium"><h6>Coins are automatically earned for every transaction made at {venueDetail?.name} using your Vemos Pay account.</h6></IonText>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mb-2x">
            <div className="loyal-icon-wrapper">
              <IonIcon
                className="loyalty-icon"
                icon={sparklesOutline}
                color="dark"
              />
            </div>

            <div className="d-flex-content ml-2">
              <IonLabel className="ion-text-wrap">
                <IonText color="dark"><h6>Exclusive offers for faster earnings</h6></IonText>
              </IonLabel>
              <IonLabel className="ion-text-wrap">
                <IonText color="medium"><h6>Watch your coins accumulate even faster with personalized offers and exclusive surprises when you join the program.</h6></IonText>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="loyal-icon-wrapper">
              <IonIcon
                className="loyalty-icon"
                icon={ribbonOutline}
                color="dark"
              />
            </div>
            <div className="d-flex-content ml-2">
              <IonLabel className="ion-text-wrap">
                <IonText color="dark"><h6>Redeem for rewards</h6></IonText>
              </IonLabel>

              <IonLabel className="ion-text-wrap">
                <IonText color="medium"><h6>Cash your coins in frequently to be treated more often, or bank them up to use toward a bigger reward.</h6></IonText>
              </IonLabel>

              {filterRewardLevels.map((item, index) => (
                <div className="loyalty-coin-wrap mt" key={index}>
                  <IonImg src="/assets/vemos-coin.png" className="coin-img-icon mr-1" />

                  <IonLabel className="ion-text-wrap mr-1">
                    <IonText color={item.points <= 25 ? "success" : item.points <= 50 ? "warning" : "tertiary"}>
                      <h6><b>{item.points}</b></h6>
                    </IonText>
                  </IonLabel>

                  <IonLabel className="ion-text-wrap">
                    <IonText color="dark"><h6>- {item.description}</h6></IonText>
                  </IonLabel>
                </div>
              ))}
            </div>
          </IonItem>

          <IonItem lines="none" className="mt-5x">
            <div className="d-flex-content d-flex-center">
              <IonButton
                color="secondary"
                expand="block"
                fill="solid"
                type="button"
                onClick={onJoinAction}
                className="loyalty-button-wrap"
              >
                <IonText color="light"><p className="loyalty-button-size">JOIN</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

LoyaltyJoinModal.propTypes = {
  isOpen: PropTypes.bool,
  setLoyaltyTypeModal: PropTypes.func,
  venueDetail: PropTypes.object,
  rewardLevels: PropTypes.array,
  programId: PropTypes.string
};

export default LoyaltyJoinModal;
